<template>
  <div>
    <validation-observer ref="transactionTypeRef">
      <b-form
        autocomplete="off"
        @submit.prevent="submitTransactionType"
      >
        <b-row>
          <b-col
            md="6"
          >
            <validation-provider
              name="Label"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Label"
                label-for="label"
              >
                <b-form-input
                  id="label"
                  v-model="transactionType.label"
                  placeholder="Label"
                  class="mb-1"
                />
                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </b-form-group>
            </validation-provider>
            <validation-provider
              v-if="isNew"
              name="Slug"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Slug"
                label-for="slug"
              >
                <b-form-input
                  id="slug"
                  v-model.trim="transactionType.slug"
                  placeholder="Slug"
                  class="mb-1"
                />
                <span
                  v-if="transactionType.slug && transactionType.slug.includes(' ')"
                  class="text-danger"
                >No allowed white spaces</span>
                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </b-form-group>
            </validation-provider>
            <validation-provider
              v-if="isNew"
              name="Code"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Code"
                label-for="code"
              >
                <b-form-input
                  id="code"
                  v-model="transactionType.code"
                  placeholder="Code"
                  class="mb-1"
                />
                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="6">
            <validation-provider
              name="Description"
              rules="required"
            >
              <b-form-group
                slot-scope="{ errors }"
                label="Description"
                label-for="description"
              >
                <b-form-textarea
                  id="description"
                  v-model="transactionType.description"
                  placeholder="Description"
                  class="mb-1"
                  rows="4"
                />

                <span class="text-danger">
                  {{ errors[0] }}
                </span>
              </b-form-group>
            </validation-provider>
            <b-form-checkbox
              v-model="transactionType.visible_credit_list"
              class="mb-1"
            >
              Visible On Credit List
            </b-form-checkbox>
            <b-form-checkbox v-model="transactionType.visible_debit_list">
              Visible On Debit List
            </b-form-checkbox>
          </b-col>
          <b-col md="6">
            <b-button
              type="submit"
              variant="primary"
              :disabled="submitBtnLoading"
            >
              <b-spinner
                v-if="submitBtnLoading"
                small
              />
              <span v-else>Submit</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  reactive, ref, onUnmounted, computed,
} from '@vue/composition-api'
import {
  BButton, BRow, BCol, BFormInput, BForm, BFormGroup, BSpinner, BFormTextarea, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import store from '@/store'
import router from '@/router'
import transactionTypesStore from '../transactionTypesStore'

export default {
  components: {
    BSpinner,
    BFormGroup,
    BForm,
    BFormInput,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    BRow,
    BCol,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, ctx) {
    const toast = useToast()
    const TRANSACTION_TYPES_STORE_MODULE_NAME = 'transactionTypes'
    if (!store.hasModule(TRANSACTION_TYPES_STORE_MODULE_NAME)) store.registerModule(TRANSACTION_TYPES_STORE_MODULE_NAME, transactionTypesStore)

    onUnmounted(() => {
      if (store.hasModule(TRANSACTION_TYPES_STORE_MODULE_NAME)) store.unregisterModule(TRANSACTION_TYPES_STORE_MODULE_NAME)
    })

    const editTransactionTypeInfo = computed(() => ctx.root.$store.getters['transactionTypes/getTransactionTypeInfo'])
    const transactionType = reactive({
      label: !props.isNew ? editTransactionTypeInfo.value.label : '',
      description: !props.isNew ? editTransactionTypeInfo.value.description : '',
      visible_credit_list: !props.isNew ? editTransactionTypeInfo.value.visible_credit_list : true,
      visible_debit_list: !props.isNew ? editTransactionTypeInfo.value.visible_debit_list : true,
    })
    const transactionTypeRef = ref(null)
    const submitBtnLoading = ref(false)
    const submitTransactionType = async () => {
      try {
        submitBtnLoading.value = true
        const isValid = await transactionTypeRef.value.validate()
        if (!isValid) return
        if (transactionType.slug.includes(' ')) return
        if (props.isNew) {
          await store.dispatch('transactionTypes/createTransactionType', transactionType)
        } else {
          await store.dispatch('transactionTypes/editTransactionType', {
            transactionType,
            id: router.currentRoute.params.id,
          })
        }
        toast({
          component: ToastificationContent,
          props: {
            title: `Transaction type ${props.isNew ? 'Created' : 'Edited'} successfully`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        router.push('/transaction-types')
      } catch (error) {
        console.log(error)
      } finally {
        submitBtnLoading.value = false
      }
    }
    return {
      required,
      submitBtnLoading,
      transactionType,
      submitTransactionType,
      transactionTypeRef,
    }
  },
}
</script>

<style scoped>

</style>
